import classes from "./HamburgerLeftBar.module.css";

export default function HamburgerLeftBar({ clickHandler }) {
  return (
    <>
      <div className={classes.HamburgerContainer} onClick={clickHandler}>
        <div className={classes.line1}></div>
        <div className={classes.line2}></div>
        <div className={classes.line3}></div>
      </div>
    </>
  );
}
